/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-edit/canned/contentEditCannedText.tmpl");
    var Multiselect = require("ui/multiselect/Multiselect");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var EditorCannedWrapperView = require("content-views/content-edit/canned/EditorCannedWrapperView");
    var LanguageTabsView = require("content-views/content-edit/LanguageTabsView");
    var HotKeysCannedView = require("content-views/content-edit/canned/HotKeysCannedView");
    var ErrorCodes = require("codeTables/errorCodes.json");

    var EditCannedTextView = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        EditCannedTextView = Marionette.ItemView.extend({
            template: template,
            className: "edit-canned-text",

            ui: {
                tabsBarContainer: ".language-tabs-container",
                editorViewContainer: ".editor-view-container",
                categoriesContainer: ".categories-container",
                skillsContainer: ".skills-container .skills-component-container",
                skillsMismatch: ".skills-container .mismatch-icon",
                lobsLabel: ".lobs-label",
                lobsContainer: ".lobs-container",
                hotkeysContainer: ".hotkeys-container",
                activeContainer: ".active-button-container"
            },
            activeTooltipTexts: {
                active: LE.translator.translate("LEContent.content.edit.activation.button.tooltip.enabled"),
                inactive: LE.translator.translate("LEContent.content.edit.activation.button.tooltip.disabled"),
                tooltipAlign: ToggleButton.TOOLTIP_ALIGN.LEFT
            },
            uiComponents: {
                tabsView: {
                    type: LanguageTabsView,
                    options: {
                        el: "view.ui.tabsBarContainer",
                        model: "view._getModel",
                        channel: "view._getChannel",
                        reqres: "view._getReqres"
                    }
                },
                editorView: {
                    type: EditorCannedWrapperView,
                    options: {
                        el: "view.ui.editorViewContainer",
                        model: "view._getModel",
                        channel: "view._getChannel"
                    }

                },
                categoriesMultiSelect: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.categoriesContainer",
                        permutation: Multiselect.PERMUTATION.FULL,
                        trim: true,
                        items: "view._getCategoriesArr",
                        list: {
                            newItem: {
                                visible: true,
                                value: LE.translator.translate("LEContent.content.edit.categories.multiselect.create")
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEContent.content.edit.categories.multiselect.placeholder")
                        }
                    },
                    events: {
                        "create"  :  "_onCategoryCreate",
                        "select"   :  "_onCategorySelectionChanged",
                        "unselect":  "_onCategorySelectionChanged"
                    }
                },
                skillsMultiSelect: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.skillsContainer",
                        permutation: Multiselect.PERMUTATION.FULL,
                        trim: true,
                        items: "view._getSkillsArr",
                        list: {
                            newItem: {
                                visible: false
                            }
                        },
                        tagsContainer: {
                            inlineErrorText: LE.translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.selectFromList"),
                            placeholder: LE.translator.translate("LEContent.content.edit.skills.multiselect.placeholder")
                        }
                    },
                    events: {
                        "select"   :  "_onSkillSelectionChanged",
                        "unselect":  "_onSkillSelectionChanged"
                    }
                },
                hotKeys: {
                    type: HotKeysCannedView,
                    options: {
                        el: "view.ui.hotkeysContainer",
                        model: "view._getModel",
                        channel: "view._getChannel"
                    }
                },
                activeButton: {
                    type: ToggleButton,
                    options: {
                        transition: ToggleButton.TRANSITION.FAST,
                        container: "view.ui.activeContainer",
                        checked: "view._getContentEnabledState",
                        tooltip: "view.activeTooltipTexts"
                    },
                    events: {
                        "toggleButton:change": "_onActivate"
                    }
                }

            },

            initialize: function (options) {
                LEContent.logger.debug("Initializing EditCannedText", "EditCannedTextView:initialize");
                this.channel = options.channel;
                this.reqres = options.reqres;
                this.contentModel = options.model.getContentModel();
                this.isTaggingByLobFeatureEnabled = options.isTaggingByLobFeatureEnabled;
                this.skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);
                this.lobsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLobsCollection);
                this.bindEvents();
            },
            onRender: function () {
                LEContent.logger.debug("onRender EditCannedTextView", "EditCannedTextView:onRender");
                this._renderLobsComponents();
                this._updateMismatchIcon();
            },

            bindEvents: function () {
                this.listenTo(this.model,"change:model",this._updateViewWithChangedModel);
                this.listenTo(this.model,"change:allowMiniErrors",this._allowMiniErrors);
            },

            _renderLobsComponents: function() {
                this.ui.lobsLabel.toggleClass("hide", !this.isTaggingByLobFeatureEnabled);
                this.ui.lobsContainer.toggleClass("hide", !this.isTaggingByLobFeatureEnabled);
                if (this.isTaggingByLobFeatureEnabled) {
                    this.uiComponents.host$.createAndRender("lobsMultiSelect", {
                        type: Multiselect,
                        options: {
                            container: "view.ui.lobsContainer",
                            permutation: Multiselect.PERMUTATION.FULL,
                            trim: true,
                            items: "view._getLobsArr",
                            list: {
                                newItem: {
                                    visible: false
                                }
                            },
                            tagsContainer: {
                                inlineErrorText: LE.translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.selectFromList"),
                                placeholder: LE.translator.translate("LEContent.content.edit.lobs.multiselect.placeholder")
                            }
                        },
                        events: {
                            "select": "_onLobSelectionChanged",
                            "unselect": "_onLobSelectionChanged"
                        }
                    });
                }
            },

            _updateViewWithChangedModel: function(){
                this._hideErrors();
                this.stopListening(this.contentModel);
                this.contentModel = this.model.getContentModel();

                this.listenTo(this.contentModel,"invalid",this._invalid);

                this.uiComponents.activeButton.setChecked(this.model.getEnabledState());
                this.uiComponents.activeButton.setEnabled(this.model.isEnabledEditable());

                this._updateCategoriesComponent();
                this._updateSkillsComponent();
                this._updateLobsComponent();
                this._updateMismatchIcon();
            },

            //categories
            _getCategoriesArr: function() {
                var categoriesCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategories);
                var categoryMultiSelectArr = [];
                categoriesCollection.each(function(model){
                    categoryMultiSelectArr.push({
                        id:    model.id,
                        value: model.getName(),
                        selected: (_.indexOf(this.model.getCategories(), model.id) > -1)
                    }) ;
                }, this);

                return categoryMultiSelectArr;
            },
            _updateCategoriesComponent: function(){
                var categoryMultiSelectCollection =  this._getCategoriesArr();
                this.uiComponents.categoriesMultiSelect.setItems(categoryMultiSelectCollection) ;
                this.uiComponents.categoriesMultiSelect.discardInput();
            },

            _getSkillsArr: function() {
                var contentLobs = this.model.getLobs();

                var skillMultiSelectArr = [];
                this.skillsCollection.each(function(skillModel){
                    var skillLobs = skillModel.getLobs();
                    var isSkillSelected = (_.indexOf(this.model.getSkills(), skillModel.id) > -1);
                    var isSkillAllowed = !this.isTaggingByLobFeatureEnabled || LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isSkillAllowedForSelection, skillLobs, contentLobs);
                    if (isSkillAllowed || isSkillSelected) {
                        skillMultiSelectArr.push({
                            id: skillModel.id,
                            value: skillModel.getName(),
                            selected: isSkillSelected
                        });
                    }
                }, this);

                return skillMultiSelectArr;
            },
            _updateSkillsComponent: function() {
                var skillsMultiSelectCollection =  this._getSkillsArr();
                this.uiComponents.skillsMultiSelect.setItems(skillsMultiSelectCollection) ;
                this.uiComponents.skillsMultiSelect.discardInput();
            },

            _getLobsArr: function() {
                var lobMultiSelectArr = [];
                this.lobsCollection.each(function(lobModel){
                    var isLobAllowed = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, lobModel.id);
                    var isLobSelected = (_.indexOf(this.model.getLobs(), lobModel.id) > -1);
                    if (isLobAllowed || isLobSelected) {
                        lobMultiSelectArr.push({
                            id: lobModel.id,
                            value: lobModel.getName(),
                            selected: isLobSelected,
                            enabled: isLobAllowed
                        }) ;
                    }
                }, this);

                return lobMultiSelectArr;
            },
            _updateLobsComponent: function() {
                if (this.isTaggingByLobFeatureEnabled) {
                    var lobsMultiSelectCollection =  this._getLobsArr();
                    this.uiComponents.lobsMultiSelect.setItems(lobsMultiSelectCollection) ;
                    this.uiComponents.lobsMultiSelect.discardInput();
                }
            },

            _updateMismatchIcon: function() {
                if (this.isTaggingByLobFeatureEnabled) {
                    var isMismatch = this.model.isMismatchLobsAndSkills(this.skillsCollection);
                    this.ui.skillsMismatch.toggleClass("hide",!isMismatch);
                }
            },

            _onCategoryCreate: function (componentId, eventName, obj) {
                var that = this;

                LEContent.logger.debug("Creating category '" + obj.value +"'","EditCannedTextView::__onCategoryCreate") ;
                var categoryCreateJson = {
                    name: obj.value
                };

                this.uiComponents.categoriesMultiSelect.setEnabled(false);
                this.uiComponents.categoriesMultiSelect.discardInput();
                this.uiComponents.categoriesMultiSelect.showLoader(true, true);

                var categoryCreateOptions = {
                    wait: true, //add to collection only if successful creation on server side
                    validate: true,
                    success: function(model, resp, options) {
                        that.uiComponents.categoriesMultiSelect.setEnabled(true);
                        that.uiComponents.categoriesMultiSelect.addItem({"id": model.id, "value": model.getName(), selected:true});
                        that.uiComponents.categoriesMultiSelect.setFocus();
                        that.uiComponents.categoriesMultiSelect.showLoader(false);
                        that._onCategorySelectionChanged();
                    },
                    error: function (model, resp, options) {
                        that.uiComponents.categoriesMultiSelect.setEnabled(true);
                        that.uiComponents.categoriesMultiSelect.showLoader(false);
                        that.uiComponents.categoriesMultiSelect.setInputValue(categoryCreateJson.name);
                        that.uiComponents.categoriesMultiSelect.setBlur();

                        if (resp && resp.responseError && !_.isEmpty(resp.responseError.message)) {
                            var errorMsg;
                            var serverErrors = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategoriesServerErrors);
                            if (resp.responseError.internalCode == ErrorCodes.uniquenessViolation){
                                errorMsg = serverErrors.duplicateName;
                                //that.uiComponents.categoriesMultiSelect.setError(true, errorMsg);  todo this is not working correctly yet
                            } else if (resp.responseError.internalCode == ErrorCodes.maxEntityLimitViolation){
                                errorMsg = serverErrors.maximumEntities;
                            } else{
                                errorMsg = resp.responseError.message;
                            }
                            LEContent.notifier.showError({content : errorMsg, timeToShow : 6000});

                        }

                        LEContent.logger.error("error creating category","EditCannedTextView::__onCategoryCreate",resp);
                    }
                };
                var categoriesCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategories);
                this.listenTo(categoriesCollection, "invalid", function() {
                    that.uiComponents.categoriesMultiSelect.setEnabled(true);
                    that.uiComponents.categoriesMultiSelect.showLoader(false);
                    that.uiComponents.categoriesMultiSelect.setInputValue(categoryCreateJson.name);
                    that.uiComponents.categoriesMultiSelect.setBlur();
                    LEContent.notifier.showError({content : LE.translator.translate("LEContent.content.edit.categories.multiselect.create.length.error"), timeToShow : 6000});
                });

                categoriesCollection.create(categoryCreateJson, categoryCreateOptions);
                this.stopListening(categoriesCollection);
            },
            _onCategorySelectionChanged: function(){
                this.channel.trigger("editCannedTextView:categories:change",this.uiComponents.categoriesMultiSelect.getSelectedItems()) ;
            },
            _onSkillSelectionChanged: function(){
                this.channel.trigger("editCannedTextView:skills:change",this.uiComponents.skillsMultiSelect.getSelectedItems()) ;
                this._updateMismatchIcon();
            },
            _onLobSelectionChanged: function(){
                this.channel.trigger("editCannedTextView:lobs:change",this.uiComponents.lobsMultiSelect.getSelectedItems()) ;
                this._updateSkillsComponent();
                this._updateMismatchIcon();
            },
            _getContentEnabledState:function(){
                return this.model.getEnabledState();
            },
            _onActivate: function (componentId, eventName, value) {
                this.channel.trigger("editCannedTextView:toggle:activate:change",value);
            },
            _getModel: function () {
                return this.model;
            },
            _getChannel: function () {
                return this.channel;
            },
            _getReqres: function () {
                return this.reqres;
            },

            _invalid: function(model, errors) {
                LEContent.logger.info("on Invalid called", "EditCannedTextView:onInvalid");
                //ValidationUtilities.setValidationErrors(this,false,this.contentModel);
            },

            _hideErrors:function () {
               // this.uiComponents.xxx.setError(false);
            },

            onClose: function () {
                LEContent.logger.debug("onClose EditCannedTextView", "EditCannedTextView:onClose");
            },

            //check for view errors in the inner components
            validateView: function() {
                var errors = 0;
                if (this.uiComponents.categoriesMultiSelect.getInputValue().length > 0) {
                    errors++;
                }
                if (this.uiComponents.skillsMultiSelect.getInputValue().length > 0) {
                    errors++;
                }
                if (this.uiComponents.lobsMultiSelect && this.uiComponents.lobsMultiSelect.getInputValue().length > 0) {
                    errors++;
                }
                return errors;
            },

            //allow for the mini bubble view errors to appear, or block them completely
            _allowMiniErrors:function (model,isShow) {
                this.uiComponents.categoriesMultiSelect.setInlineError(isShow);
                this.uiComponents.skillsMultiSelect.setInlineError(isShow);
                if (this.uiComponents.lobsMultiSelect) {
                    this.uiComponents.lobsMultiSelect.setInlineError(isShow);
                }
            }
        });
    });
    return EditCannedTextView;
});
